import React, { useEffect, useState } from 'react';
import { Container, Col, Dropdown, Row, Modal, Form, Button } from 'react-bootstrap';
import { apiRequest } from '../utils/apiHelper';
import { AppContext } from '../App';
export const Enquiry = () => {
    const { enquiries, setEnquiries, getLoad, link, accessToken, setAccessToken, leadStatues } = React.useContext(AppContext);
    const [load, setLoad] = useState(false);
    const [activeId, setActiveId] = useState();
    const [assignModal, setAssignModal] = useState(false);
    const assignStaff = (e) => {
        e.preventDefault();
        let staff = e.target.staff.value;
        if (staff !== "" && activeId !== "") {
            apiRequest({
                url: `${link}api/cs/lead/assign/user/`,
                method: 'POST',
                data: {
                    name: staff,
                    l_id: activeId.substring(1)
                },
                token: accessToken,
                setLoading: setLoad,
                setAccessToken: setAccessToken,
                onSuccess: (data) => {
                    setEnquiries(prev => ({ ...prev, [data.id]: data.values }));
                    setAssignModal(false);
                }
            });
        }
    }
    useEffect(() => {
        if (!assignModal) { setActiveId(); }
    }, [assignModal]);
    const [updateDetailsModal, setUpdateDetailsModal] = useState(false);
    const updateLeadDetails = (e) => {
        e.preventDefault();
        let conpany_name = e.target.cname.value;
        let location = e.target.location.value;
        let email = e.target.email.value;
        let estimate = e.target.estimate.value;
        let details = e.target.details.value;
        if (conpany_name !== "" && location !== "" && estimate !== "" && details !== "") {
            apiRequest({
                url: `${link}api/cs/update/lead/details/`,
                method: 'POST',
                data: {
                    company_name: conpany_name,
                    location: location,
                    email: email,
                    estimated_value: estimate,
                    requirement: details,
                    l_id: activeId.substring(1)
                },
                token: accessToken,
                setLoading: setLoad,
                setAccessToken: setAccessToken,
                onSuccess: (data) => {
                    if (data.status) {
                        setUpdateDetailsModal(false);
                        alert('Success');
                    } else {
                        alert(data.message ?? 'Something went wrong');
                    }
                }
            });
        }

    }
    useEffect(() => {
        if (!updateDetailsModal) { setActiveId(); }
    }, [updateDetailsModal]);
    const formatDateTime = (isoString) => {
        if (!isoString) return '-';
        const d = new Date(isoString);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}`;
    };
    const [updateEventModal, setUpdateEventModal] = useState(false);
    const updateEvent = (e) => {
        e.preventDefault();
        let eid = e.target.eid.value;
        let note = e.target.note.value;
        if (eid !== "" && note !== "" && activeId !== "" && activeId !== undefined) {
            apiRequest({
                url: `${link}api/cs/add/lead/events/`,
                method: 'POST',
                data: {
                    ls_id: eid.substring(1),
                    l_id: activeId.substring(1),
                    note: note,
                },
                token: accessToken,
                setLoading: setLoad,
                setAccessToken: setAccessToken,
                onSuccess: (data) => {
                    if (data.status) {
                        setUpdateEventModal(false);
                        alert('Success');
                    } else {
                        alert(data.message ?? 'Something went wrong');
                    }
                }
            });
        }
    }
    const [leadDetails, setLeadDetails] = useState();
    const [detailModal, setDetailModal] = useState(false);
    const getLeadDetails = (lid) => {
        if (lid !== "" && lid !== undefined) {
            apiRequest({
                url: `${link}api/cs/get/lead/details/`,
                method: 'POST',
                data: {
                    l_id: lid.substring(1),
                },
                token: accessToken,
                setLoading: setLoad,
                setAccessToken: setAccessToken,
                onSuccess: (data) => {
                    setLeadDetails(data);

                }
            });
        }
    }
    return (
        <Container className='py-2' >
            {
                getLoad ? (<div>Loading...</div>) : (
                    enquiries !== undefined && Object.keys(enquiries).length > 0 ? (
                        Object.keys(enquiries).map((item, index) => (
                            <Row key={`enq_${index}`} className='bgs1 bdr1 br-4 py-2 mb-1' >
                                <Col xs={12} sm={12} md={8} >
                                    <div className='d-grid'>
                                        <h6>{enquiries[item].title}</h6>
                                        <span className='f14 tp3' >Source : {enquiries[item].lead_source ?? '-'}, Customer : {enquiries[item].name ?? '-'}, {enquiries[item].phone ?? '-'}</span>
                                        <span className='f12 tp3' >{enquiries[item].desc ?? '-'}</span>
                                    </div>
                                </Col>
                                <Col>
                                    <div className='flex-wrap gap-2 align-items-center justify-content-end '>
                                        <span>{enquiries[item].status}</span>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                                <i className="fa-solid fa-ellipsis"></i>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {
                                                    enquiries[item].assigned_to === null ? (
                                                        <Dropdown.Item onClick={() => {
                                                            setActiveId(item);
                                                            setAssignModal(true);
                                                        }} >Assign to staff</Dropdown.Item>
                                                    ) : null
                                                }
                                                <Dropdown.Item onClick={() => {
                                                    setActiveId(item);
                                                    setUpdateDetailsModal(true);
                                                }} >Update Details</Dropdown.Item>
                                                <Dropdown.Item onClick={() => {
                                                    setActiveId(item);
                                                    setUpdateEventModal(true);
                                                }} >Update Events</Dropdown.Item>
                                                <Dropdown.Item onClick={() => {
                                                    getLeadDetails(item);
                                                    setDetailModal(true);
                                                }} >Details</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                    <div className='d-grid align-items-center justify-content-end' >
                                        <span className='f12 tp3' >Created : {formatDateTime(enquiries[item].created_at)}</span>
                                        <span className='f12 tp3' >Updated : {formatDateTime(enquiries[item].updated_at)}</span>
                                    </div>
                                </Col>
                            </Row>
                        ))
                    ) : 'Nothing Found!'
                )
            }
            <Modal show={assignModal} onHide={() => { setAssignModal(false) }} size='lg' >
                <Modal.Header closeButton>
                    <Modal.Title>Assign Enquiry</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={assignStaff}>
                        <Form.Group controlId="formBasicStaff" className='mb-2' >
                            <Form.Label>Staff</Form.Label>
                            <Form.Control type="text" name='staff' placeholder="Enter staff name" />
                        </Form.Group>
                        <div className='d-grid'>
                            {
                                load ? (
                                    <Button variant="primary" disabled>Please wait...</Button>
                                ) : (
                                    <Button variant="primary" type='submit' >Assign</Button>
                                )
                            }
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
            <Modal show={updateDetailsModal} onHide={() => { setUpdateDetailsModal(false) }} size='lg' >
                <Modal.Header closeButton>
                    <Modal.Title>Update Enquiry Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={updateLeadDetails}>
                        <Form.Group controlId="formBasicCompanyName" className='mb-2' >
                            <Form.Label>Company Name</Form.Label>
                            <Form.Control type="text" name='cname' placeholder="Enter company name" />
                        </Form.Group>
                        <Form.Group controlId="formBasicLocation" className='mb-2' >
                            <Form.Label>Location</Form.Label>
                            <Form.Control type="text" name='location' placeholder="Enter location" />
                        </Form.Group>
                        <Form.Group controlId="formBasicEmail" className='mb-2' >
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" name='email' placeholder="Enter email" />
                        </Form.Group>
                        <Form.Group controlId="formBasicEstimate" className='mb-2' >
                            <Form.Label>Estimate</Form.Label>
                            <Form.Control type="text" name='estimate' placeholder="Enter estimate" />
                        </Form.Group>
                        <Form.Group controlId="formBasicDetails" className='mb-2' >
                            <Form.Label>Requirements</Form.Label>
                            <Form.Control type="text" as="textarea" rows={4} name='details' placeholder="Enter details" />
                        </Form.Group>
                        <div className='d-grid'>
                            {
                                load ? (
                                    <Button variant="primary" disabled>Please wait...</Button>
                                ) : (
                                    <Button variant="primary" type='submit' >Update</Button>
                                )
                            }
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
            <Modal show={updateEventModal} onHide={() => setUpdateEventModal(false)} >
                <Modal.Header closeButton>
                    <Modal.Title>Update Event</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={updateEvent}>
                        <Form.Group controlId="formBasicEvent" className='mb-2' >
                            <Form.Label>Lead Status</Form.Label>
                            <Form.Select name='eid' >
                                <option value=''>Choose lead status</option>
                                {
                                    leadStatues && Object.keys(leadStatues).length > 0 && Object.keys(leadStatues).map((item, index) => (
                                        <option key={index} value={item}>{leadStatues[item].name}</option>
                                    ))
                                }
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="formBasicNote" className='mb-2' >
                            <Form.Label>Note</Form.Label>
                            <Form.Control type="text" as="textarea" rows={4} name='note' placeholder="Enter note" />
                        </Form.Group>
                        <div className='d-grid'>
                            {
                                load ? (
                                    <Button variant="primary" disabled>Please wait...</Button>
                                ) : (
                                    <Button variant="primary" type='submit' >Update</Button>
                                )
                            }
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
            <Modal show={detailModal} onHide={() => setDetailModal(false)} size='lg' >
                <Modal.Header closeButton>
                    <Modal.Title>{load ? 'Loading...' : 'Lead Details'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        leadDetails !== undefined ? (
                            <>
                                {
                                    leadDetails.main !== undefined ? (
                                        <div className='d-grid gap-2 mb-2' >
                                            <div className='d-flex align-items-center justify-content-between' >
                                                <div className='d-grid' >
                                                    <h5>{leadDetails.main.title}</h5>
                                                    <span className='f12 tp3' >{leadDetails.main.desc ?? '-'}</span>
                                                    <span className='f12 tp3' >Lead Source : {leadDetails.main.lead_source ?? '-'}</span>
                                                    <span className='f12 tp3' >Assigned To : {leadDetails.main.assigned_to ?? '-'}</span>
                                                </div>
                                                <div className='d-grid align-items-end text-end' >
                                                    <span >Status : {leadDetails.main.status ?? '-'}</span>
                                                    <span className='tp3 f12' >Created : {leadDetails.main.created_date ?? '-'}, {leadDetails.main.created_time ?? '-'}</span>
                                                    <span className='tp3 f12' >Updated : {leadDetails.main.updated_date ?? '-'}, {leadDetails.main.updated_time ?? '-'}</span>
                                                </div>
                                            </div>
                                            <div className='d-flex justify-content-between ' >
                                                <div className='d-grid' >
                                                    <h6>Customer Details</h6>
                                                    <span className='f14 tp3' >Name : {leadDetails.main.name ?? '-'}</span>
                                                    <span className='f14 tp3' >Email : {leadDetails.main.email ?? '-'}</span>
                                                    <span className='f14 tp3' >Phone : {leadDetails.main.phone ?? '-'}</span>
                                                </div>
                                                <div className='d-grid' >
                                                    <h6>Lead Details</h6>
                                                    <span className='f14 tp3' >Location : {leadDetails.main.location ?? '-'}</span>
                                                    <span className='f14 tp3' >Company Name : {leadDetails.main.company_name ?? '-'}</span>
                                                    <span className='f14 tp3' >Estimate : {leadDetails.main.estimated_value ?? '-'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ) : 'Main details Not found'
                                }
                                {
                                    leadDetails.data !== undefined && Object.keys(leadDetails.data).length > 0 ? (
                                        Object.keys(leadDetails.data).map((item, index) => (
                                            <div key={index} className='d-flex justify-content-between bgs2 mb-1 bdr1 p-2 br-3' >
                                                <div className='d-grid' >
                                                    <span>{leadDetails.data[item].event_label}</span>
                                                    <span className='f14 tp3' >{leadDetails.data[item].notes}</span>
                                                </div>
                                                <div className='d-grid text-end' >
                                                    <span>{leadDetails.data[item].event_type}</span>
                                                    <span className='f12 tp2' >{leadDetails.data[item].created_date ?? ''}, {leadDetails.data[item].created_time ?? ''}</span>
                                                </div>
                                            </div>
                                        ))
                                    ) : 'Data Not found'
                                }
                            </>
                        ) : null
                    }
                </Modal.Body>
            </Modal>
        </Container>
    )
}